// extracted by mini-css-extract-plugin
module.exports = {"gwContactsTabContainer":"Contacts_gwContactsTabContainer__3RjA5","gwSectionTitle":"Contacts_gwSectionTitle__2Vgg6"};